export default {"src":"/_next/static/media/office-icon-selected.9668045b.svg","height":96,"width":59,"blurWidth":0,"blurHeight":0};